import React from 'react';

export const HeartWrapperLazy = React.lazy(() =>
    import(
        /* webpackChunkName: "HeartWrapper" */
        'dibs-portfolio-heart'
    )
);
